import DealerLooseItemListPanel from "./dealerLooseItemListPanel.container"

export default DealerLooseItemListPanel
